import React from 'react';
import { Badge } from '@chakra-ui/react';
import type { LinkStatus } from '../../types/link';

// Matches xNotify's CustomBadge solid-pill style — soft tinted background +
// matching dark text. See App/src/components/SharedComponent/Badge.jsx.
const PALETTE: Record<LinkStatus, { bg: string; color: string }> = {
  active:   { bg: '#dcfce7', color: '#166534' },
  expired:  { bg: '#e2e8f0', color: '#475569' },
  disabled: { bg: '#fee2e2', color: '#991b1b' },
};

export const LinkStatusBadge: React.FC<{ status: LinkStatus }> = ({ status }) => {
  const p = PALETTE[status];
  return <Badge bg={p.bg} color={p.color}>{status}</Badge>;
};
